
<template>
  <section class="wrapper login-wrapper">

    <section v-show="state === 'verificationError'">
      <div class="field">
        <h1>Verification Code</h1>
        <p>An error occurred while sending a verification code via text message. Please contact Cars Helping Charities to verify your account has a valid mobile number attached.</p>
      </div>
      <div class="field buttons">
        <a @click="sendVerificationCode" class="secondary-action">Resend Verification Code</a>
      </div>
    </section>

    <section v-show="state === 'resetPassword'">
      <div class="field">
        <h1>Verification Code</h1>
        <p>A verification code has been sent via text message. Please enter it below.</p>
      </div>
      <div class="field">
        <chc-input v-model="user.secret" label="Verification Code"></chc-input>
      </div>
       <div v-if="resetPasswordPage.errors.error" class="field"><span class="error-message">{{ resetPasswordPage.errors.error }}</span></div>
      <div class="field buttons">
        <input type="submit" class="btn" :value="resetPasswordPage.processing ? 'Processing...' : 'Continue'"
               @click="resetPassword">
        <a @click="sendVerificationCode" class="secondary-action">Resend Verification Code</a>
      </div>
    </section>

    <!-- Set Password -->
    <section v-show="state === 'setPassword'">
      <div class="field">
        <h1>Password</h1>
      </div>
      <div class="field">
        <chc-input v-model="user.password" label="New Password" type="password" :error="resetPasswordPage.errors.password"></chc-input>
      </div>
      <div class="field">
        <chc-input v-model="user.password_confirmation" label="Confirm Password" type="password" :error="resetPasswordPage.errors.password_confirmation"></chc-input>
      </div>
      <div v-if="resetPasswordPage.errors.confirmed" class="field"><span class="error-message">{{ resetPasswordPage.errors.confirmed }}</span></div>
      <div class="field buttons">
        <input class="btn" value="Save" @click="submit" type="submit">
      </div>
    </section>

    <section v-show="state === 'success'">
      <div class="field">
        <h1>Set Password </h1>
        <p>Your password has been changed!</p>
      </div>
    </section>
  </section>
</template>

<script>
import auth from '@/auth'
export default {
  name: 'ResetPassword',
  mounted () {
    this.sendVerificationCode()
  },
  data () {
    return {
      // resetPassword setPassword success
      state: 'resetPassword',
      auth: auth,
      user: {
        password: null,
        password_confirmation: null,
        secret: null
      },
      resetPasswordPage: {
        errors: {},
        processing: false
      }
    }
  },
  methods: {
    sendVerificationCode () {
      auth.sendVerificationCode(this.auth.user, () => {
        this.state = 'resetPassword'
      }, () => {
        this.state = 'verificationError'
      })
    },
    resetPassword () {
      this.state = 'setPassword'
    },
    submit () {
      let self = this
      this.resetPasswordPage.processing = true
      auth.resetPassword(this, this.user, () => {
        this.resetPasswordPage.errors = {}
        this.state = 'success'
      }, (resp) => {
        self.resetPasswordPage.errors = resp.response.data.errors
        if (self.resetPasswordPage.errors.error === 'Unauthorized') {
          self.state = 'resetPassword'
          self.user.secret = null
          self.user.password = null
          self.user.password_confirmation = null
        }
        self.resetPasswordPage.processing = false
      })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue